import { socketHost, qmsocketHost } from '@/utils/hostsconfig'
import connectlog from '@/utils/connectlog'
import { getQueryString } from '@/utils'
let connectTimer

const relogin = () => {
  location.reload()
}
const roleObject = {
  '1':'STUDENT',
  '2':'PARENT',
  '3':'HEADMASTER',
  '4':'TEACHER',
  '5':'OPERATOR',
  '6':'CC',
  '7':'ASSISTANT'
}
var nodeEnv = process.env.NODE_ENV
console.log({nodeEnv})
const sendSocketMsg = data => {
  $_chat.sendKeepalive(data)
}

const appName = getQueryString('app_name') || sessionStorage.getItem('supervise_app_name') || '';
const APP_HOST_MAP = { qimeng: qmsocketHost };

const connectSocket = userInfo => {
  
  let socketConnInfo = {
    host: APP_HOST_MAP[appName] || socketHost,
    port: '80'
  }
  if (window.location.protocol === 'https:') {
    socketConnInfo.port = '443'
  }
  console.log(roleObject[userInfo.user_type],userInfo.user_type)
  let connMsg = {
    'event': 'LOGIN',
    'teacher_id': userInfo.teacher_id,
    'subject_id': userInfo.subject_id,
    'school_id': userInfo.school_id,
    'nick': userInfo.nick,
    'app_type': userInfo.app_type, // (1: 线上, 2:线下）
  }
  if (userInfo.user_type != 4) {
    connMsg = Object.assign(connMsg, {
      'refer_teacher_id': userInfo.refer_teacher_id,
      'refer_school_id':userInfo.refer_school_id,
      'user_type': userInfo.user_type, // (1.学生 2.家长 3.校长 4.分析员 5.场务 6.课程顾问(CC)  7场控）
      'subrole': roleObject[userInfo.user_type],//(HEADMASTER:校长，CC:课程顾问, OPERATOR:运营)
      'role': 'SUPERVISOR', // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
    })
  } else {
    connMsg = Object.assign(connMsg, {
      'refer_teacher_id': userInfo.refer_teacher_id,
      'user_type': userInfo.user_type, // (1.学生 2.家长 3.校长 4.分析员 5.场务 6.课程顾问(CC)  7场控）
      'role': roleObject[userInfo.user_type], // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
    })
  }
  console.log({socketConnInfo,connMsg})
  $_chat.init(socketConnInfo.host, socketConnInfo.port, connMsg, function(msg, err) {
      console.log({msg, err})
      if (msg == 'connect_timeout' || msg == 'connect_error' || msg == 'connected')
        connectlog(msg, err,userInfo)
  })
  window.clearInterval(connectTimer)

  connectTimer = window.setInterval(function() {
    var timestamp = (new Date()).valueOf()
    var nowTime = parseInt(timestamp / 1000)
    var _m = {
      'event': 'KEEPALIVE',
      'teacher_id': userInfo.teacher_id,
      'subject_id': userInfo.subject_id,
      'school_id': userInfo.school_id,
      'nick': userInfo.nick,
      'app_type': userInfo.app_type, // (1: 线上, 2:线下）
      'client_time': nowTime,
      // 'role': roleObject[userInfo.user_type],
      'user_agent': navigator.userAgent
    }
    if (userInfo.user_type != 4) {
      _m = Object.assign(_m, {
        'refer_teacher_id': userInfo.refer_teacher_id,
        'user_type': userInfo.user_type, // (1.学生 2.家长 3.校长 4.分析员 5.场务 6.课程顾问(CC)  7场控）
        'subrole': roleObject[userInfo.user_type],//(HEADMASTER:校长，CC:课程顾问, OPERATOR:运营)
        'role': 'SUPERVISOR', // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
      })
    } else {
      _m = Object.assign(_m, {
        'refer_teacher_id': userInfo.refer_teacher_id,
        'user_type': userInfo.user_type, // (1.学生 2.家长 3.校长 4.分析员 5.场务 6.课程顾问(CC)  7场控）
        'role': roleObject[userInfo.user_type], // :SUPERVISOR，(STUDENT:学生, TEACHER:分析员, SUPERVISOR:监控者)
      })
    }
    console.log({_m})
    sendSocketMsg(_m)
  }, 300000)
}

export default connectSocket



// WEBPACK FOOTER //
// ./src/utils/connectSocket.js